import { apiClient } from '@/lib/api/client';
export const reportsApi = {
    async getAttendanceSummary(params) {
        const { data } = await apiClient.get(`/api/v1/reports/attendance/${params.groupId}`, { params: { dateFrom: params.dateFrom, dateTo: params.dateTo } });
        return data;
    },
    async getPassengerManifest(groupId) {
        const { data } = await apiClient.get(`/api/v1/reports/manifest/${groupId}`);
        return data;
    },
    async getGroupOccupancy(params) {
        const { data } = await apiClient.get(`/api/v1/reports/occupancy`, { params: params });
        return data;
    },
    async getCoordinatorStats(params) {
        const { data } = await apiClient.get(`/api/v1/reports/coordinator`, { params: params });
        return data;
    },
    async getTourScanPerformance(params) {
        const { data } = await apiClient.get(`/api/v1/reports/tourscan`, { params: params });
        return data;
    },
};
export function exportToCSV(data, columns, filename) {
    if (!data.length)
        return;
    const header = columns.map(c => c.header).join(',');
    const rows = data.map(row => columns.map(c => {
        const val = row[c.key];
        const str = val == null ? '' : String(val);
        return str.includes(',') ? `"${str}"` : str;
    }).join(','));
    const csv = [header, ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}
export function formatDate(dateStr) {
    if (!dateStr)
        return '—';
    return new Date(dateStr).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
}
//# sourceMappingURL=reports.js.map